export function paginateRows<T>(rows: T[], limit: number, page: number): T[] {
  return rows.slice(page * limit, (page + 1) * limit);
}
